import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../rest/RestoForm.css";
import { Typography, Tabs, Tab, Box, Alert } from '@mui/material';

const RestForm = () => {
  const [users, setUsers] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    user_id: '',
    contractor_id: '',
    restaurant_id: '',
    contractor_name: '',
    restaurant_name: '',
    uid: '',
    type: 'solo'
  });
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    region: "uk-UA" // Додаємо значення за замовчуванням
  });
  
  const [userHasContractor, setUserHasContractor] = useState(false);
  const [emailAlreadyExists, setEmailAlreadyExists] = useState(false);
  const [usernameAlreadyExists, setUsernameAlreadyExists] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchUsers(),
          fetchContractors(),
          fetchRestaurants()
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchData();
  }, []);

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get('https://bank2.daolog.net/users');
      setUsers(data);
    } catch (error) {
      setError('Помилка при завантаженні користувачів');
      throw error;
    }
  };

  const fetchContractors = async () => {
    try {
      const { data } = await axios.get('https://bank2.daolog.net/contractors');
      setContractors(data);
    } catch (error) {
      setError('Помилка при завантаженні контрагентів');
      throw error;
    }
  };

  const fetchRestaurants = async () => {
    try {
      const { data } = await axios.get('https://bank2.daolog.net/restaurants');
      setRestaurants(data);
    } catch (error) {
      setError('Помилка при завантаженні ресторанів');
      throw error;
    }
  };

  const checkUserContractor = async (userId) => {
    try {
      const { data } = await axios.get(`https://bank2.daolog.net/check-user-contractor/${userId}`);
      setUserHasContractor(data.hasContractor);
      if (data.hasContractor) {
        setError('У користувача вже є контрагент');
        setSuccess('');
      } else {
        setError('');
      }
    } catch (error) {
      console.error('Error checking user contractor:', error);
      setSuccess('');
    }
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'user_id') {
      checkUserContractor(value);
    }
    setError('');
    setSuccess('');
  };

  const handleRegisterChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (userHasContractor) {
      setError('У користувача вже є контрагент');
      setSuccess('');
      return;
    }
    if (!formData.user_id) {
      setError('Будь ласка, виберіть користувача');
      setSuccess('');
      return;
    }
    try {
      await axios.post('https://bank2.daolog.net/add-contractor-to-user', {
        user_id: parseInt(formData.user_id),
        contractor_name: formData.contractor_name,
      });
      
      await fetchContractors();
      setFormData(prev => ({ ...prev, contractor_name: '' }));
      setError('');
      setSuccess('Клієнта успішно додано до користувача');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при додаванні контрагента');
      setSuccess('');
    }
  };

  const handleRegisterSubmit = (event) => {
    event.preventDefault();
    if (values.password !== values.confirmPassword) {
      setPasswordMatch(false);
      setError('Паролі не співпадають');
      setSuccess('');
    } else {
      // Створюємо об'єкт з усіма необхідними полями
      const userData = {
        username: values.username,
        email: values.email,
        password: values.password,
        region: values.region || 'uk-UA' // Додаємо значення за замовчуванням
      };
  
      axios
        .post("https://bank2.daolog.net/signup", userData)
        .then((res) => {
          setSuccess('Користувача успішно зареєстровано');
          setError('');
          setTimeout(() => {
            window.location.href = "/RestForm";
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 400) {
            if (err.response.data.message === "Username already exists") {
              setUsernameAlreadyExists(true);
              setError('Користувач з таким іменем вже існує');
            } else if (err.response.data.message === "Email already exists") {
              setEmailAlreadyExists(true);
              setError('Користувач з такою поштою вже існує');
            } else {
              setError(err.response.data.message || 'Помилка при реєстрації користувача');
            }
          } else {
            setError('Помилка при реєстрації користувача');
          }
          setSuccess('');
        });
    }
  };
  const handleAddRestaurant = async (event) => {
    event.preventDefault();
    try {
      await axios.post('https://bank2.daolog.net/add-restaurant-to-contractor', {
        contractor_id: formData.contractor_id,
        restaurant_name: formData.restaurant_name,
        uid: formData.uid,
      });

      await fetchRestaurants();
      setFormData(prev => ({ ...prev, restaurant_name: '', uid: '' }));
      setSuccess('Ресторан успішно додано');
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при додаванні ресторану');
      setSuccess('');
    }
  };

  const handleAddContractor = async (event) => {
    event.preventDefault();
    try {
      await axios.post('https://bank2.daolog.net/add-contractor', {
        name: formData.contractor_name,
        type: formData.type
      });

      await fetchContractors();
      setFormData(prev => ({ ...prev, contractor_name: '', type: 'solo' }));
      setSuccess('Клієнта успішно створено');
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при створенні контрагента');
      setSuccess('');
    }
  };

  const renderAddRestaurantForm = () => (
    <form onSubmit={handleAddRestaurant}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        name="contractor_id"
        value={formData.contractor_id}
        onChange={handleChange}
        required
      >
        <option value="">Виберіть клієнта</option>
        {contractors.map(({ id, name }) => (
          <option key={id} value={id}>{name}</option>
        ))}
      </select>
      <input
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        type="text"
        name="restaurant_name"
        value={formData.restaurant_name}
        onChange={handleChange}
        placeholder="Назва ресторану"
        required
      />
      <input
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        type="text"
        name="uid"
        value={formData.uid}
        onChange={handleChange}
        placeholder="UID ресторану"
        required
      />
      <button
        className="input-stl"
        style={{ marginTop: "15px" }}
        type="submit"
      >
        Додати ресторан до клієнта
      </button>
    </form>
  );

  const renderAddUserContractorForm = () => (
    <form onSubmit={handleSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        name="user_id"
        value={formData.user_id}
        onChange={handleChange}
        required
      >
        <option value="">Виберіть користувача</option>
        {users.map(({ id, username }) => (
          <option key={id} value={id}>{username}</option>
        ))}
      </select>
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        disabled={userHasContractor}
        required
      >
        <option value="">Виберіть або введіть нового клієнта</option>
        {Array.from(new Set(contractors.map(c => c.name))).map(name => (
          <option key={name} value={name}>{name}</option>
        ))}
      </select>
      <button
        className="input-stl"
        style={{ marginTop: "15px" }}
        type="submit"
        disabled={userHasContractor}
      >
        Додати клієнта до користувача
      </button>
    </form>
  );

  const renderAddNewContractorForm = () => (
    <form onSubmit={handleAddContractor}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <input
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        type="text"
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        placeholder="Назва нового клієнта"
        required
      />
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)" }}
        name="type"
        value={formData.type}
        onChange={handleChange}
        required
      >
        <option value="solo">Solo</option>
        <option value="chain">Chain</option>
      </select>
      <button
        className="input-stl"
        style={{ marginTop: "15px" }}
        type="submit"
      >
        Додати нового клієнта
      </button>
    </form>
  );

  const renderAddNewUserForm = () => (
    <form onSubmit={handleRegisterSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <label style={{
        display: "flex",
        flexDirection: "column",
        width: "380px",
        marginLeft: "auto",
        marginTop: "10px",
        marginRight: "auto",
        alignItems: "center",
      }}>
        Username:
        <input
          className="input-stl"
          style={{
            marginTop: "10px",
            backgroundColor: "rgb(213, 220, 255)"
          }}
          placeholder="Username"
          type="text"
          name="username"
          onChange={handleRegisterChange}
        />
      </label>

      <br />
      <label style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
      }}>
        Email:
        <input
          className="input-stl"
          style={{
            marginTop: "10px",
            backgroundColor: "rgb(213, 220, 255)"
          }}
          placeholder="Email"
          type="email"
          name="email"
          onChange={handleRegisterChange}
        />
      </label>
      <br />
      
      <label style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
      }}>
        Password:
        <input
          className="input-stl"
          style={{
            marginTop: "10px",
            backgroundColor: "rgb(213, 220, 255)"
          }}
          placeholder="Password"
          type="password"
          name="password"
          onChange={handleRegisterChange}
        />
      </label>
      <br />
      <label style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
      }}>
        Confirm Password:
        <input
          className="input-stl"
          style={{
            marginTop: "10px",
            backgroundColor: "rgb(213, 220, 255)"
          }}
          placeholder="Confirm Password"
          type="password"
          name="confirmPassword"
          onChange={handleRegisterChange}
        />
      </label>
      <br />
      <label style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: "auto",
        marginRight: "auto",
        alignItems: "center",
      }}>
        Країна:
        <select
          className="input-stl"
          style={{
            marginTop: "10px",
            backgroundColor: "rgb(213, 220, 255)"
          }}
          name="region"
          value={values.region}
          onChange={handleRegisterChange}
        >
          <option value="uk-UA">Україна</option>
          <option value="pl-PL">Польща</option>
        </select>
      </label>
      <br />
      <button
        className="input-stl"
        type="submit"
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: "auto",
          marginRight: "auto",
          alignItems: "center",
          minWidth: "50px",
          maxWidth: "200px",
          width: "100%",
          marginBottom: "15px",
        }}
      >
        Створити нового користувача
      </button>
    </form>
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setError('');
    setSuccess('');
    setFormData({
      user_id: '',
      contractor_id: '',
      restaurant_id: '',
      contractor_name: '',
      restaurant_name: '',
      uid: '',
      type: 'solo'
    });
    setValues({
      username: "",
      email: "",
      password: ""
    });
    setEmailAlreadyExists(false);
    setUsernameAlreadyExists(false);
    setPasswordMatch(true);
  };

  return (
    <div className="br-m" style={{ marginTop: "120px" }}>
      <div className="container-about-ll">
        <Typography variant="h5" gutterBottom>
          Управління клієнтами та ресторанами
        </Typography>
        
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          sx={{ 
            borderRight: 1, 
            borderColor: 'divider',
            '& .MuiTab-root': {
              justifyContent: 'center'
            }
          }}
        >
          <Tab label="Додати ресторан до клієнта" />
          <Tab label="Додати клієнта до користувача" />
          <Tab label="Додати клієнта" />
          <Tab label="Додати нового користувача" />
        </Tabs>

        <Box sx={{ padding: 2 }}>
          {activeTab === 0 && renderAddRestaurantForm()}
          {activeTab === 1 && renderAddUserContractorForm()}
          {activeTab === 2 && renderAddNewContractorForm()}
          {activeTab === 3 && renderAddNewUserForm()}
        </Box>
      </div>
    </div>
  );
};

export default RestForm;